export default __webpack_public_path__ + "static/media/header-logo.952b4961.png";